import React from 'react';

import Modal from '../../components/Modal';
import TeamMembers from './TeamMembers';

const DeleteBmcOwnerModal = ({
  visible,
  onClose,
  onOwnerDelete,
  ownerId,
  users,
  locales,
}) => {
  const filteredUsers = users.filter((u) => u.id !== ownerId);

  return (
    <Modal
      className="bmc-modal--form"
      isOpen={visible}
      onClose={onClose}
      title="Choose project owner"
    >
      <div className="bmc-form-fieldset margin-top-20 margin-bottom-20">
        <div className="bmc-form-label-sub">
          The user is project owner. Therefore you need choose another project
          project owner instead.
        </div>
      </div>

      <div className="bmc-form">
        <TeamMembers
          locales={locales}
          users={filteredUsers}
          onChooseConfirm={onOwnerDelete}
          ownerId={ownerId}
          isOwnerChoose
        />
        <div className="bmc-form-line" />
      </div>
    </Modal>
  );
};

export default DeleteBmcOwnerModal;
